import { cn } from '@/lib/utils'
import { calculateFundsDistributed } from '../utils'

interface ProgressBarProps {
  totalDistributed: number
  totalRemaining: number
  className?: string
}

export function ProgressBar({
  totalDistributed,
  totalRemaining,
  className,
}: ProgressBarProps) {
  const totalFunded = calculateFundsDistributed({
    totalAvailable: totalDistributed + totalRemaining,
    totalDistributed,
  })
  return (
    <div className={cn('w-full bg-gray-200 rounded-full h-2', className)}>
      <div
        className="bg-primary h-2 rounded-full transition-all duration-300"
        style={{ width: `${totalFunded}%` }}
      />
    </div>
  )
}

export default ProgressBar
